import React from "react"
export function Snacks(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M16.25 1a.5.5 0 01.493.577l-.02.081-.73 2.195.008.03c.5 2.076.75 4.127.75 6.155 0 2.028-.25 4.056-.75 6.082l-.01.023.734 2.199.02.08a.5.5 0 01-.403.57L16.25 19H3.75l-.083-.007a.5.5 0 01-.412-.562l.021-.09.73-2.198-.012-.053-.165-.922C3.444 12.932 3.25 11.212 3.25 10c0-1.055.147-2.497.44-4.33l.14-.838.164-.922.014-.052-.733-2.2a.5.5 0 01.391-.651L3.749 1h12.5zM6.663 16.5h-1.72l-.5 1.5h11.112l-.5-1.5h-1.721l.287.572-.894.447-.511-1.019H10.5v.796h-1V16.5H7.783l-.51 1.02-.894-.448.285-.572zm8.455-11.999L4.902 4.5l-.077.445c-.336 1.936-.524 3.47-.566 4.597l-.006.235L4.25 10c0 .939.127 2.229.38 3.866l.125.78.147.854h10.216l.063-.27c.285-1.298.463-2.596.534-3.894l.027-.65.008-.648c0-1.62-.166-3.259-.499-4.915l-.132-.622zM10 5.75c2.599 0 4.75 1.645 4.75 3.75s-2.151 3.75-4.75 3.75-4.75-1.645-4.75-3.75S7.401 5.75 10 5.75zm0 1c-2.096 0-3.75 1.265-3.75 2.75s1.654 2.75 3.75 2.75 3.75-1.265 3.75-2.75S12.096 6.75 10 6.75zM15.555 2H4.442l.5 1.5h1.72l-.285-.572.895-.447.51 1.019h1.717v-.796h1V3.5h1.717l.51-1.02.895.448-.287.572h1.721l.5-1.5z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__snacks"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
